import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_2: FaireProductEntity = {
  token: "nyc-soap-2",
  type: "product",
  name: "Lavender Bar Soap",
  brandName: "Brooklyn Botanicals",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6fe22033c0a43e1151fa29444e8b1f602112ed24e1a870f22e5ea1be018775c3.webp",
  priceDollars: 12,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6fe22033c0a43e1151fa29444e8b1f602112ed24e1a870f22e5ea1be018775c3.webp",
  weight: 0.4,
  dimensions: {
    width: 3,
    height: 4,
    depth: 1.5,
  },
  description: "Vegan botanical bar soap from Brooklyn",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "vegan", "brooklyn"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
